var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09091 9.98582C4.09091 9.33719 4.19864 8.71535 4.39091 8.13209L1.02545 5.5621C0.369545 6.89384 0 8.39444 0 9.98582C0 11.5758 0.369091 13.0755 1.02409 14.4064L4.38773 11.8314C4.19727 11.2508 4.09091 10.6313 4.09091 9.98582Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.08511C11.4091 4.08511 12.6818 4.5844 13.6818 5.40142L16.5909 2.49645C14.8182 0.953191 12.5455 0 10 0C6.04818 0 2.65182 2.25997 1.02545 5.5621L4.39091 8.13208C5.16636 5.77816 7.37682 4.08511 10 4.08511Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.8865C7.37682 15.8865 5.16636 14.1935 4.39091 11.8395L1.02545 14.4091C2.65182 17.7117 6.04818 19.9716 10 19.9716C12.4391 19.9716 14.7677 19.1056 16.5155 17.4829L13.3209 15.0132C12.4195 15.581 11.2845 15.8865 10 15.8865Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5455 9.98581C19.5455 9.39574 19.4545 8.76028 19.3182 8.17021H10V12.0284H15.3636C15.0955 13.3438 14.3655 14.3551 13.3209 15.0132L16.5155 17.4829C18.3514 15.7789 19.5455 13.2407 19.5455 9.98581Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2071e61c1a7a6ad472f3bd47d37f21dc.svg";
export { ForwardRef as ReactComponent };